import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLang } from "redux/slices/translations/translationSlice";
import { NavLink } from "react-router-dom";

// Components
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

// Utils
import { Translate } from "utils/translations/Translate";

// Styles
import classNames from "classnames";
import styles from "./Header.module.scss";
import logo from "assets/images/general/gmbldr_logo.svg";

const languages = {
    en: {
        iso: "EN",
        icon: (
            <svg
                width="16"
                height="10"
                viewBox="0 0 60 30"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 4 }}
            >
                <rect width="60" height="30" fill="#012169" />
                <path
                    d="M0 0 L60 30 M60 0 L0 30"
                    stroke="#fff"
                    strokeWidth="6"
                />
                <path
                    d="M0 0 L60 30 M60 0 L0 30"
                    stroke="#C8102E"
                    strokeWidth="4"
                />
                <path
                    d="M30 0 L30 30 M0 15 L60 15"
                    stroke="#fff"
                    strokeWidth="10"
                />
                <path
                    d="M30 0 L30 30 M0 15 L60 15"
                    stroke="#C8102E"
                    strokeWidth="6"
                />
            </svg>
        ),
    },
    ru: {
        iso: "RU",
        icon: (
            <svg
                width="16"
                height="10"
                viewBox="0 0 3 2"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 4 }}
            >
                <rect width="3" height="2" fill="#999" />
            </svg>
        ),
    },
    ua: {
        iso: "UA",
        icon: (
            <svg
                width="16"
                height="10"
                viewBox="0 0 3 2"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 4 }}
            >
                <rect width="3" height="1" fill="#0057B7" />
                <rect y="1" width="3" height="1" fill="#FFD700" />
            </svg>
        ),
    },
    fr: {
        iso: "FR",
        icon: (
            <svg
                width="16"
                height="10"
                viewBox="0 0 3 2"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 4 }}
            >
                <rect width="1" height="2" x="0" fill="#0055A4" />
                <rect width="1" height="2" x="1" fill="#fff" />
                <rect width="1" height="2" x="2" fill="#EF4135" />
            </svg>
        ),
    },
    es: {
        iso: "ES",
        icon: (
            <svg
                width="16"
                height="10"
                viewBox="0 0 3 2"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 4 }}
            >
                <rect width="3" height="0.5" fill="#AA151B" />
                <rect y="0.5" width="3" height="1" fill="#F1BF00" />
                <rect y="1.5" width="3" height="0.5" fill="#AA151B" />
            </svg>
        ),
    },
};

function Header() {
    const dispatch = useDispatch();
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { lang } = useSelector((state) => state.translations);

    // initialize translate class
    const translation = new Translate("headerFactory", lang);
    const t = translation.getWord();

    const handleLanguageClick = (lang) => {
        dispatch(setLang(lang));
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", () =>
                setScrolled(window.scrollY > 2)
            );
        }
    }, []);

    useEffect(() => {
        if (expanded) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
    }, [expanded]);

    return (
        <header className={styles.header}>
            <Navbar
                fixed="top"
                expanded={expanded}
                expand="xl"
                className={classNames({ scrolled: scrolled })}
            >
                <div className="container d-flex w-100 justify-content-between align-items-center">
                    <NavLink className={"logo-gmbldr"} to="/">
                        <img src={logo} alt="logo-gmbldr" />
                    </NavLink>
                    <div className={styles.lang_block}>
                        <NavDropdown
                            title={
                                <span
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {languages[lang].icon}
                                    {languages[lang].iso}
                                </span>
                            }
                            id="basic-nav-dropdown"
                        >
                            {Object.keys(languages).map((l, i) => (
                                <NavDropdown.Item
                                    key={i}
                                    onClick={() => handleLanguageClick(l)}
                                    active={lang === l}
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {languages[l].icon}
                                    {languages[l].iso}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </div>
                </div>
            </Navbar>
        </header>
    );
}

export default Header;
